import { UserSessionsForDebugApi } from "../../generated"
import { useQuery } from 'react-query'
import { apiConfig } from "../apiConfig"
import { DebugLoginOption } from "./DebugLoginOption"
import { onError } from "../../approver/stores/user/UserStore"

const api = new UserSessionsForDebugApi(apiConfig)

async function load() {
  return await api.listApprover()
}

export function useApproverList() {
  const { data } = useQuery('useApproverList', load, { onError })
  const options: DebugLoginOption[] | undefined = data?.map(approver => { return { value: approver.account, label: `${approver.name} (${approver.account})` } })
  return options ? options : []
}
